import {
  Flex,
  Text,
  Box,
  Image,
  Button,
  Center,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import useGenerateForgetPasswordToken from "../../api/mutations/useGenerateForgetPasswordToken";
import FormikInput from "../../components/formikinput";

const ForgotPasswordPage = () => {
  const toast = useToast();
  const navigate = useNavigate();

  const tokenMutation = useGenerateForgetPasswordToken();

  const handleSubmit = async (email) => {
    try {
      if (!email) {
        toast({
          title: "Email is missing",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }
      const response = await tokenMutation.mutateAsync({ email: email });
      if (response.status === 200) {
        navigate("/forgot-password/email-sent");
        return;
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "Failed to send request",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid Email")
        .required("Email cannot be empty"),
    }),
    onSubmit: async (values) => handleSubmit(values.email),
  });

  return (
    <Flex>
      <Box flex={1} bg={"black"}>
        <Center height={"100vh"}>
          <Flex
            alignItems={"center"}
            direction={"column"}
            bg={"grey.400"}
            w={"462px"}
            padding={4}
          >
            <Image
              src={require("../../assets/logo.svg").default}
              w={88}
              h={76}
            />
            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
            >
              KIDSWEAR
            </Text>
            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
            >
              COLLECTIVE
            </Text>

            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
              marginBlock={8}
            >
              Business Team
            </Text>

            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
              marginBottom={"16px"}
            >
              FORGOT PASSWORD
            </Text>

            <Box mb={"16px"} w={"100%"}>
              <Text
                color={"#FFFFFF"}
                fontFamily={"PlusJakartaSansRegular"}
                fontSize={"12px"}
                marginBottom={"16px"}
              >
                Enter email to the account you forgot password off.
              </Text>
              <FormikInput
                name="email"
                type="text"
                label="Email Address"
                labelColor={"white"}
                color="#fff"
                placeholder="Enter your email address"
                formik={formik}
              />
            </Box>
            <Button
              onClick={formik.handleSubmit}
              isDisabled={
                !formik.dirty || tokenMutation.isLoading || !formik.values.email
              }
              w={"100%"}
              borderRadius={8}
              bg={"primary.500"}
              color={"#FFFFFF"}
              fontSize={14}
              fontFamily={"PlusJakartaSansMedium"}
              textTransform={"uppercase"}
              _hover={{
                bg: "#273979",
                color: "#737373",
              }}
              _disabled={{
                bg: "transparent",
                border: "1px solid white",
                cursor: "initial",
              }}
            >
              {tokenMutation.isLoading ? <Spinner /> : "SUBMIT"}
            </Button>
          </Flex>
        </Center>
      </Box>
    </Flex>
  );
};

export default ForgotPasswordPage;
